import React from "react";
import { PinIcon } from "components/icons/Icons";

export const LocationPin = () => (
    <div className="pin" style={{ marginTop: "-30px" }}>
        <PinIcon />
    </div>
);
